import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { QRCodeModule } from 'angularx-qrcode';

import { BtPhoneInputComponent } from '@app/shared/components/bt-phone-input/bt-phone-input.component';
import { BrightrButtonDirective } from '@app/shared/directives/brightr-button.directive';
import { CustomNgxMaskModule } from '@app/shared/libs/custom-ngx-mask.module';
import { MaterialIconsModule } from '@app/shared/modules/material-icons.module';
import * as directives from '../../directives';
import {
  AutoFocusDirective,
  BackgroundLoadedDirective,
  SetBackgroundDirective,
} from '../../directives';
import * as pipes from '../../pipes';
import { PhonePipe } from '../../pipes';
import { ModalComponentModule } from '../modal/modal.component.module';
import { AuthComponent } from './auth.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    ModalComponentModule,
    CustomNgxMaskModule,
    QRCodeModule,
    MatTooltipModule,
    MaterialIconsModule,
    MatProgressSpinnerModule,
    BrightrButtonDirective,
    BtPhoneInputComponent,
  ],
  declarations: [
    AuthComponent,
    pipes.PhonePipe,
    directives.AutoFocusDirective,
    directives.BackgroundLoadedDirective,
    directives.SetBackgroundDirective,
  ],
  exports: [
    AuthComponent,
    PhonePipe,
    AutoFocusDirective,
    SetBackgroundDirective,
    BackgroundLoadedDirective,
  ],
  providers: [],
})
export class AuthComponentModule {}
